import React, { useEffect, useState } from "react";
import AppContainer from "../components/AppContainer";
import { Images } from "../constants/Images";
import OpsBtn from "../ops-library/ops-btn";
import { useNavigate } from "react-router-dom";
import IntroSlides from "../components/IntroSlides";
import OpsText from "../ops-library/ops-text";
import ArticlePreview from "../components/app/ArticlePreview";
import axios from "axios";
import validator from "validator";
import { LoadingSpinner } from "../components/LoadingSpinner";
import ConcertPreview from "../components/app/ConcertPreview";
import ReactStars from "react-rating-stars-component";
import { FaPhoneAlt } from "react-icons/fa";
import { FaEnvelope } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import OpsInput from "../ops-library/ops-input";
import { Form, Modal } from "react-bootstrap";
import { SectionHeader } from "../components/SectionHeader";
import { opsConfirmDialog } from "../ops-library/ops-confirm-dialog";
import opsToast from "../ops-library/ops-toast";
import { isValidSlovakPhoneNumber } from "../functions/isValidSlovakPhoneNumber";
import {
  ALBUM_CD_ID,
  ALBUM_USB_ID,
  CASH_ON_DELIVERY_ID,
  PERSON_PICKUP_ID,
} from "../constants/constants";

const Introduction = () => {
  const navigate = useNavigate();
  const [webData, setWebData] = useState(null);
  const [articles, setArticles] = useState(null);
  const [concerts, setConcerts] = useState(null);
  const [images, setImages] = useState(null);
  const [productCD, setProductCD] = useState(null);
  const [productUSB, setProductUSB] = useState(null);
  const [cashOnDelivery, setCashOnDelivery] = useState(null);
  const [personPickup, setPersonPickup] = useState(null);
  const [modalConcertShown, setModalConcertShown] = useState(false);
  const [modalDataConcert, setModalDataConcert] = useState({
    posterImg: "",
    ticketsUrl: "",
    price: null,
  });
  const [processed, setProcessed] = useState(false);

  useEffect(() => {
    getWebAppInfo();
    getAllPublishedArticles();
    getAllPublishedConcerts();
    getImages();
    // CD, USB, DOBIERKA, OSOBNY ODBER
    getAlbumInfo([
      ALBUM_CD_ID,
      ALBUM_USB_ID,
      CASH_ON_DELIVERY_ID,
      PERSON_PICKUP_ID,
    ]);
  }, []);

  // API volania
  // ------------------------------------------------------------------------------
  function getImages() {
    const configuration = {
      method: "get",
      url: `${process.env.REACT_APP_API_BASE_URL}/upload`,
    };

    axios(configuration)
      .then((result) => {
        setImages(result.data.content);
      })
      .catch((error) => {
        opsToast(
          error.response?.data?.message,
          "error",
          "colored",
          true,
          "top-center",
        );
      });
  }

  function getWebAppInfo() {
    const configuration = {
      method: "get",
      url: `${process.env.REACT_APP_API_BASE_URL}/webdata/`,
    };

    axios(configuration)
      .then((result) => {
        setWebData(result.data.content);
      })
      .catch((error) => {
        console.log(error);
        navigate("/");
      });
  }

  function getAllPublishedArticles() {
    const configuration = {
      method: "get",
      url: `${process.env.REACT_APP_API_BASE_URL}/articles/published?limit=3`,
    };

    axios(configuration)
      .then((result) => {
        setArticles(result.data.content);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getAllPublishedConcerts() {
    const configuration = {
      method: "get",
      url: `${process.env.REACT_APP_API_BASE_URL}/concerts/published?limit=8`,
    };

    axios(configuration)
      .then((result) => {
        setConcerts(result.data.content);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getAlbumInfo(ids) {
    const idParams = Array.isArray(ids) ? ids.join("|") : ids;

    const configuration = {
      method: "get",
      url: `${process.env.REACT_APP_API_BASE_URL}/products/product_ids=${idParams}`,
    };

    axios(configuration)
      .then((result) => {
        let temp = result.data.content;
        setProductCD(temp?.find((product) => product._id === ALBUM_CD_ID));
        setProductUSB(temp?.find((product) => product._id === ALBUM_USB_ID));
        setPersonPickup(
          temp?.find((product) => product._id === PERSON_PICKUP_ID),
        );
        setCashOnDelivery(
          temp?.find((product) => product._id === CASH_ON_DELIVERY_ID),
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // INFO sekcia
  // ------------------------------------------------------------------------------
  const InfoSection = ({ id }) => {
    return (
      <div
        className="fa-flex-row fa-w-100 justify-content-center align-items-center mt-5"
        id={id}
      >
        <div className="desktop-row-phone-col fa-w-90 mt-5 gap-5 align-items-center justify-content-center">
          {/*FOTKA*/}
          <div className="desktop-50-phone-100 phone-not-shown">
            <img src={Images.BETARKY} className="w-100 h-100" alt="" />
          </div>
          {/*INFOTEXT*/}
          <div className="desktop-50-phone-100 fa-flex-col">
            <OpsText
              type="title8 px-1 mb-3"
              weight={800}
              color="color-1"
              alignment="left"
              content={"Beťarky"}
            />
            <OpsText
              type="normal4 px-1"
              weight={300}
              color="color-1"
              alignment="justify"
              content={webData?.description}
            />
          </div>
        </div>
      </div>
    );
  };

  // Koncerty
  // ------------------------------------------------------------------------------
  const ConcertsSection = ({ id }) => {
    return (
      <div className="fa-flex-col align-items-center mt-5" id={id}>
        <SectionHeader title="Najbližšie koncerty" url="koncerty" />
        <div className="fa-flex-wrap fa-w-90 justify-content-start mt-4 gap-3">
          {concerts?.map((item, index) => (
            <ConcertPreview
              concert={item}
              key={index}
              action={() =>
                (item.posterImg || item.ticketsUrl.length > 0) &&
                handleOpenModalConcert({
                  posterImg: item.posterImg,
                  ticketsUrl: item.ticketsUrl,
                  price: item.price,
                })
              }
            />
          ))}
        </div>
      </div>
    );
  };

  function handleOpenModalConcert(data) {
    if (data) {
      setModalConcertShown(true);
      setModalDataConcert(data);
    }
  }

  function handleModalsClose() {
    setModalConcertShown(false);
    setModalDataConcert({ posterImg: "", ticketsUrl: "", price: null });
  }

  const ModalConcert = ({ show = false, onHide }) => {
    return (
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName="custom-modal-container"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="modal-background-color"
        />

        <Modal.Body className="modal-background-color fa-flex-col align-items-center">
          <div className="custom-modal-content">
            {modalDataConcert?.posterImg && (
              <div className="concert-poster mt-5">
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/${modalDataConcert?.posterImg}`}
                  className="w-100 h-100 object-fit-cover"
                  alt=""
                />
              </div>
            )}

            {modalDataConcert?.ticketsUrl.length > 0 && (
              <div className="desktop-row-phone-col mt-5 mb-3 w-100 justify-content-center">
                <OpsBtn
                  text="Kúpiť lístky"
                  variant="primary"
                  size="md mt-2"
                  action={() =>
                    window.open(
                      modalDataConcert?.ticketsUrl,
                      "_blank",
                      "noreferrer",
                    )
                  }
                />
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  // Produkty - CD
  // ------------------------------------------------------------------------------
  const ProductSection = ({ id }) => {
    // OBJEDNAVKOVY FORMULAR
    const OrderForm = () => {
      const [name, setName] = useState("");
      const [email, setEmail] = useState("");
      const [phone, setPhone] = useState("");
      const [street, setStreet] = useState("");
      const [nr, setNr] = useState("");
      const [city, setCity] = useState("");
      const [postalCode, setPostalCode] = useState("");
      const [notes, setNotes] = useState("");
      const [quantity, setQuantity] = useState(1);
      const [price, setPrice] = useState(productCD?.price);
      const [selectedProduct, setSelectedProduct] = useState(productCD);
      const [selectedMethod, setSelectedMethod] = useState(personPickup);

      function validateOrderData() {
        if (!name || name.trim().length < 3) {
          opsToast("Zadajte platné meno (min. 3 znaky)", "error");
          setProcessed(false);
          return false;
        }
        if (!validator.isEmail(email)) {
          opsToast("Zadajte platný e-mail", "error");
          setProcessed(false);
          return false;
        }
        if (!isValidSlovakPhoneNumber(phone)) {
          opsToast("Zadajte platné slovenské telefónne číslo", "error");
          setProcessed(false);
          return false;
        }
        if (!street || !nr || !city || !postalCode) {
          opsToast("Vyplňte všetky dodacie údaje", "error");
          setProcessed(false);
          return false;
        }
        if (!validator.isNumeric(postalCode) || postalCode.length !== 5) {
          opsToast("Zadajte platné PSČ (5 čísel)", "error");
          setProcessed(false);
          return false;
        }
        if (quantity <= 0 || !Number.isInteger(quantity)) {
          opsToast("Nevalidný počet kusov!", "error");
          setProcessed(false);
          return;
        }
        if (price < 0) {
          opsToast("Cena nie je validná!", "error");
          setProcessed(false);
          return false;
        }
        if (selectedProduct === null) {
          opsToast("Žiaden produkt nie je zvolený!", "error");
          setProcessed(false);
          return false;
        }
        if (selectedMethod === null) {
          opsToast("Žiaden spôsob doručenia nie je zvolený!", "error");
          setProcessed(false);
          return false;
        }

        return true;
      }

      function createOrder() {
        setProcessed(true);
        opsToast(
          "Vaša objednávka sa aktuálne spracováva. Ak budú všetky potrebné dáta v poriadku, o pár sekúnd príde notifikácia o jej úspešnom spracovaní.",
          "default",
          "colored",
          true,
          "top-center",
          7000,
        );
        const orderData = {
          customer: {
            name: name,
            email: email,
            phone: phone,
            addressStreet: street,
            addressNr: nr,
            addressCity: city,
            addressPostalCode: postalCode,
          },
          products: [
            {
              productId: selectedProduct._id,
              name: selectedProduct.name,
              quantity: quantity,
              price: selectedProduct.price,
            },
            {
              productId: selectedMethod._id,
              name: selectedMethod.name,
              quantity: 1,
              price: selectedMethod.price,
            },
          ],
          totalPrice: price + selectedMethod?.price,
          shipping: {
            method: selectedMethod.description,
            shippingCost: selectedMethod.price,
          },
          notes: notes,
          personalDataConsent: true,
        };

        const configuration = {
          method: "post",
          url: `${process.env.REACT_APP_API_BASE_URL}/orders/new`,
          data: orderData,
        };

        axios(configuration)
          .then((result) => {
            opsToast(
              result?.data?.message,
              "success",
              "colored",
              true,
              "top-center",
              10000,
            );
            setName("");
            setEmail("");
            setPhone("");
            setStreet("");
            setNr("");
            setCity("");
            setPostalCode("");
            setNotes("");
            setSelectedProduct(productCD);
            setSelectedMethod(personPickup);
            setQuantity(1);
            setPrice(productCD?.price);
          })
          .catch((error) => {
            opsToast(
              error?.response?.data?.message,
              "error",
              "colored",
              true,
              "top-center",
            );
          });
        setProcessed(false);
      }

      return (
        <div className="fa-flex-col fa-w-90">
          <OpsText
            type="title6 mt-5 mb-4"
            weight={700}
            color="color-1"
            content="Chcem si objednať CD"
          />

          {!processed ? (
            <div className="desktop-row-phone-col fa-w-100 gap-4">
              {/*FORMULAR*/}
              <div className="desktop-50-phone-100 fa-flex-col gap-1 justify-content-between">
                {/*Meno a priezvisko*/}
                <OpsInput
                  size="100"
                  type="text"
                  id="name"
                  value={name}
                  label="OSOBNÉ ÚDAJE"
                  labelWeight={700}
                  className="desktop-50-phone-100"
                  placeholder="Meno a priezvisko"
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
                {/*Emailova adresa*/}
                <OpsInput
                  size="100"
                  type="email"
                  id="email"
                  value={email}
                  className="desktop-50-phone-100"
                  placeholder="Emailová adresa (napr. tom@mail.com)"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
                {/*Tel. cislo*/}
                <OpsInput
                  size="100"
                  type="tel"
                  id="phone"
                  value={phone}
                  className="desktop-50-phone-100"
                  placeholder="Telefónne číslo (0915 123 654)"
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
                <div className="desktop-row-phone-col align-items-end gap-1 fa-w-100">
                  {/*Ulica*/}
                  <OpsInput
                    size="md"
                    type="text"
                    id="street"
                    componentClassName="desktop-75-phone-100"
                    value={street}
                    label="DODACIE ÚDAJE"
                    labelWeight={700}
                    placeholder="Ulica"
                    onChange={(e) => {
                      setStreet(e.target.value);
                    }}
                  />
                  {/*Cislo domu*/}
                  <OpsInput
                    size="sm"
                    type="text"
                    componentClassName="desktop-25-phone-100"
                    value={nr}
                    labelWeight={700}
                    placeholder="Číslo"
                    onChange={(e) => {
                      setNr(e.target.value);
                    }}
                  />
                </div>
                {/*Mesto*/}
                <OpsInput
                  size="100"
                  type="text"
                  id="city"
                  value={city}
                  className="desktop-50-phone-100"
                  placeholder="Mesto"
                  onChange={(e) => {
                    setCity(e.target.value);
                  }}
                />
                {/*PSC*/}
                <OpsInput
                  size="100"
                  type="text"
                  id="zip"
                  value={postalCode}
                  className="desktop-50-phone-100"
                  placeholder="PSČ (08256) - bez medzier"
                  onChange={(e) => {
                    setPostalCode(e.target.value);
                  }}
                />
                {/*Poznamky*/}
                <OpsInput
                  customType="textarea"
                  className=""
                  value={notes}
                  maxLength={350}
                  label="POZNÁMKY"
                  labelWeight={700}
                  placeholder="Zadajte doplňujúce informácie k objednávke..."
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>

              {/*POPIS PRODUKTU + DORUCENIE*/}
              <div className="desktop-50-phone-100 fa-flex-col justify-content-between">
                <OpsText
                  type="normal2 px-1"
                  weight={300}
                  color="color-1"
                  alignment="justify"
                  content={productCD?.description}
                />

                <div className="fa-flex-col">
                  {/*TYP PRODUKTU*/}
                  <OpsText
                    type="normal2 px-1 mt-3 mb-2"
                    weight={700}
                    color="color-1"
                    alignment="justify"
                    content="VYBERTE TYP NOSIČA"
                    // content="VYBERTE TYP NOSIČA - USB/CD"
                  />
                  <div className="fa-flex-col gap-1">
                    <OpsInput
                      customType="checkBox"
                      className="mt-0"
                      id="cd-type-check"
                      label="CD"
                      value={selectedProduct?._id === ALBUM_CD_ID}
                      onChange={() => {
                        setSelectedProduct(productCD);
                      }}
                    />
                    {/* <OpsInput
                      customType="checkBox"
                      className="mt-0"
                      id="usb-type-check"
                      label="USB"                    
                      tooltip="Momentálne nie je možné objednať USB verziu - produkt nie je dostupný."
                      disabled={true}
                      value={selectedProduct?._id === ALBUM_USB_ID}
                      onChange={() => {
                        setSelectedProduct(productUSB);
                      }}
                    /> */}
                  </div>

                  {/*SPOSOB DORUCENIA*/}
                  <OpsText
                    type="normal2 px-1 mt-3 mb-2"
                    weight={700}
                    color="color-1"
                    alignment="justify"
                    content="VYBERTE SPÔSOB DORUČENIA"
                  />
                  <div className="fa-flex-col gap-1">
                    <OpsInput
                      customType="checkBox"
                      className="mt-0"
                      id="pickup-check"
                      label="osobné vyzdvihnutie (Pečovská Nová Ves) - zadarmo"
                      value={selectedMethod?._id === PERSON_PICKUP_ID}
                      onChange={() => {
                        setSelectedMethod(personPickup);
                      }}
                    />
                    <OpsInput
                      customType="checkBox"
                      className="mt-0"
                      id="standard-check"
                      label="doprava poštou - 6€"
                      value={selectedMethod?._id === CASH_ON_DELIVERY_ID}
                      onChange={() => {
                        setSelectedMethod(cashOnDelivery);
                      }}
                    />
                  </div>

                  {/*POCET KUSOV + CENA*/}
                  <div className="fa-flex-row justify-content-between">
                    <div className="fa-flex-col">
                      <OpsText
                        type="normal2 px-1 mt-3 mb-2"
                        weight={700}
                        color="color-1"
                        alignment="left"
                        content="POČET KUSOV"
                      />
                      <div className="fa-flex-row align-items-center">
                        <OpsBtn
                          icon={
                            <FaMinus
                              color="color-1"
                              className="ops-icon-sm m-1"
                            />
                          }
                          variant="icon m-1 p-1 bg-black"
                          padding={false}
                          action={() => {
                            if (quantity > 1) {
                              setQuantity(quantity - 1);
                              setPrice((quantity - 1) * productCD?.price);
                            }
                          }}
                        />
                        <OpsText
                          type="normal3 px-1"
                          weight={700}
                          color="color-1"
                          alignment="justify"
                          content={`${quantity} ks`}
                        />
                        <OpsBtn
                          icon={
                            <FaPlus
                              color="color-1"
                              className="ops-icon-sm m-1"
                            />
                          }
                          variant="icon m-1 p-1 bg-black"
                          padding={false}
                          action={() => {
                            if (quantity <= 9) {
                              setQuantity(quantity + 1);
                              setPrice((quantity + 1) * productCD?.price);
                            } else {
                              opsToast(
                                "V jednej objednávke je možné objednať max. 10 ks CD. Ak máte záujem o viac kusov, kontaktujte nás.",
                                "error",
                                "colored",
                                true,
                                "top-center",
                              );
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="fa-flex-col">
                      <OpsText
                        type="normal2 px-1 mt-3 mb-2"
                        weight={700}
                        color="color-1"
                        alignment="right"
                        content="CENA"
                      />
                      <OpsText
                        type="normal4 px-1"
                        weight={900}
                        color="color-1"
                        alignment="right"
                        content={`${price + selectedMethod?.price} €`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="py-5">
              <LoadingSpinner />
            </div>
          )}

          {/*ODOSLANIE FORMULARA*/}
          {!processed && (
            <div className="fa-flex-col fa-w-100 mt-4 align-items-center justify-content-center">
              <OpsBtn
                text="Objednať"
                variant="primary"
                size="bg"
                id="create-order-btn"
                // tooltipText="Objednávanie CD zatiaľ nie je možné, skúste to neskôr."
                // disabled
                fontWeight={700}
                action={async (e) =>
                  validateOrderData() &&
                  opsConfirmDialog(
                    "Vytvorenie objednávky",
                    `Kliknutím nižšie na tlačidlo "Potvrdiť" súhlasite so spracovaním vašich osobných údajov pre potreby pripravenia a odoslania vašej objednávky. Naozaj si prajete vytvoriť objednávku v celkovej cene ${price + selectedMethod?.price} €?`,
                    "dark",
                    () => createOrder(),
                    () => {},
                  )
                }
              />
            </div>
          )}
        </div>
      );
    };

    return (
      <div className="fa-flex-col align-items-center mt-5" id={id}>
        <SectionHeader title="CD - „Beťar sme dzivečki“" />

        <div className="desktop-row-phone-col fa-w-90 align-items-center mt-4 gap-5">
          {/*NAHLAD CD*/}
          <div className="desktop-25-phone-100 overflow-hidden">
            <img
              src={Images.CD}
              className="w-100 h-100 intro-img-scale"
              alt=""
            />
          </div>
          {/* ZOZNAM PIESNI - 2 stplce */}
          <div className="desktop-75-phone-100 desktop-row-phone-col justify-content-center gap-4">
            <div className="desktop-50-phone-100 fa-flex-col gap-2">
              {productCD?.tracklist
                .slice(0, productCD?.tracklist.length / 2)
                .map((item, index) => (
                  <OpsText
                    type="normal2 cd-song-title-text"
                    weight={350}
                    color="color-1"
                    key={index}
                    alignment="left"
                    content={item}
                  />
                ))}
            </div>
            <div className="desktop-50-phone-100 fa-flex-col gap-2">
              {productCD?.tracklist
                .slice(
                  productCD?.tracklist.length / 2,
                  productCD?.tracklist.length,
                )
                .map((item, index) => (
                  <OpsText
                    type="normal2 cd-song-title-text"
                    weight={350}
                    color="color-1"
                    key={index}
                    alignment="left"
                    content={item}
                  />
                ))}
            </div>
          </div>
        </div>
        {/*OBJEDNAVACI FORMULAR*/}
        <OrderForm />
      </div>
    );
  };

  // Aktuality - clanky
  // ------------------------------------------------------------------------------
  const ActualitiesSection = ({ id }) => {
    return (
      <div className="fa-flex-col align-items-center mt-5" id={id}>
        <SectionHeader title="Aktuality" url="aktuality" />
        <div className="fa-flex-wrap fa-w-90 align-items-center justify-content-center mt-4 gap-3">
          {articles?.map((item, index) => (
            <ArticlePreview article={item} key={index} />
          ))}
        </div>
      </div>
    );
  };

  // Galeria
  // ------------------------------------------------------------------------------
  const GallerySection = ({ id }) => {
    return (
      <div className="fa-flex-col align-items-center mt-5" id={id}>
        <SectionHeader title="Galéria" />
        <div className="fa-flex-wrap fa-w-90 align-items-center justify-content-center mt-4 gap-0">
          {images
            ?.sort((a, b) => a.order - b.order)
            .map((img, index) => (
              <div
                className="gallery-img-preview pointer-cursor overflow-hidden"
                key={index}
              >
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/${img.path}`}
                  className="w-100 h-100 intro-img-scale"
                  alt=""
                />
              </div>
            ))}
        </div>
      </div>
    );
  };

  // Kontakty
  // ------------------------------------------------------------------------------
  const ContactSection = ({ id }) => {
    const [rating, setRating] = useState(0);
    const [name, setName] = useState("");
    const [comment, setComment] = useState("");

    // API request - POST review
    function postReview() {
      setProcessed(true);
      const data = {
        rating: rating,
        name: name,
        comment: comment,
      };

      const configuration = {
        method: "post",
        url: `${process.env.REACT_APP_API_BASE_URL}/reviews`,
        data: data,
        headers: {},
      };

      axios(configuration)
        .then((result) => {
          opsToast(result?.data?.message, "success");
          handleModalsClose();
        })
        .catch((error) => {
          console.log(error);
          opsToast(error.message, "error", "colored", true, "top-center");
        });
      setProcessed(false);
    }

    return (
      <div className="fa-flex-col align-items-center mt-5" id={id}>
        <SectionHeader title="Kontaktné informácie" />
        <div className="desktop-row-phone-col fa-w-90  mt-4 justify-content-between gap-4">
          {/* Kontakt-info */}
          <div className="fa-flex-col desktop-50-phone-100">
            <div className="fa-flex-col mb-3">
              <OpsText
                type="title1"
                weight={700}
                color="color-1"
                alignment="left"
                content={webData?.contactName}
              />
              <OpsText
                type="normal2 fst-italic"
                weight={300}
                color="color-1"
                alignment="left"
                content="Rodinné oslavy, svadby, verejné koncerty..."
              />
            </div>
            {/* UDAJE */}
            <div className="fa-flex-col gap-1">
              <div className="fa-flex-row align-items-center gap-3">
                <FaPhoneAlt color="white" className="ops-icon-bg m-1" />
                <OpsText
                  type="normal1"
                  weight={400}
                  color="color-1"
                  alignment="left"
                  content={webData?.phoneNumber}
                />
              </div>
              <div className="fa-flex-row align-items-center gap-3">
                <FaEnvelope color="white" className="ops-icon-bg m-1" />
                <OpsText
                  type="normal1"
                  weight={400}
                  color="color-1"
                  alignment="left"
                  content={webData?.emailAddress}
                />
              </div>
              <div className="fa-flex-row align-items-center gap-3">
                <FaInstagram color="white" className="ops-icon-bg m-1" />
                <OpsBtn
                  btnText
                  text="lh_betarky"
                  textColor="color-1 txt-normal1"
                  fontWeight={400}
                  textStyle="text-left my-1"
                  action={() => (window.location.href = webData.igUrl)}
                />
              </div>
              <div className="fa-flex-row align-items-center gap-3">
                <FaFacebookSquare color="white" className="ops-icon-bg m-1" />
                <OpsBtn
                  btnText
                  text="ĽH Beťarky"
                  textColor="color-1 txt-normal1"
                  fontWeight={400}
                  textStyle="text-left my-1"
                  action={() => (window.location.href = webData.fbUrl)}
                />
              </div>
            </div>
          </div>
          {/* Recenzie */}
          <div className="fa-flex-col desktop-50-phone-100" id="review">
            <OpsText
              type="title1"
              weight={700}
              color="color-1"
              alignment="left"
              content="Pridanie recenzie"
            />

            <div className="fa-flex-col">
              <OpsText
                type="normal1 mb-neg2"
                weight={200}
                color="color-1"
                alignment="left"
                content="Vaše hodnotenie"
              />
              <Form
                className="fa-flex-col gap-1"
                onSubmit={(e) => postReview(e)}
              >
                <ReactStars
                  count={5}
                  onChange={setRating}
                  size={40}
                  isHalf={true}
                  emptyIcon={<i className="far fa-star"></i>}
                  halfIcon={<i className="fa fa-star-half-alt"></i>}
                  fullIcon={<i className="fa fa-star"></i>}
                  activeColor="#ffd700"
                />
                <OpsInput
                  size="100"
                  type="string"
                  value={name}
                  placeholder="Vaše meno"
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
                <OpsInput
                  customType="textarea"
                  className=""
                  value={comment}
                  maxLength={500}
                  placeholder="Tu nám môžete zanechať krátku recenziu..."
                  onChange={(e) => setComment(e.target.value)}
                />

                <div className="w-100 justify-content-start">
                  <OpsBtn
                    id="review-send"
                    text="Odoslať"
                    variant="primary"
                    size="md mt-2"
                    fontWeight={700}
                    action={async (e) => postReview(e)}
                  />
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <AppContainer
      header={
        webData !== null && <IntroSlides img={Images.IMG_1} />
        // webData !== null && <IntroSlides img={webData.introHeaderImg}/>
      }
      content={
        webData !== null ? (
          <div className="window-content-container gap-4">
            <ModalConcert
              show={modalConcertShown}
              onHide={() => handleModalsClose()}
            />
            {articles !== null ? (
              <div className="fa-flex-col gap-3">
                <InfoSection id="information" />
                <ConcertsSection id="concerts" />
                <ProductSection id="product" />
                <ActualitiesSection id="actualities" />
                <GallerySection id="gallery" />
                <ContactSection id="contact" />
              </div>
            ) : (
              <div className="py-5">
                <LoadingSpinner />
              </div>
            )}
          </div>
        ) : (
          <div className="window-content-container gap-4">
            <LoadingSpinner />
          </div>
        )
      }
    />
  );
};

export default Introduction;
